export default "__VITE_ASSET__D_ofwl8c__"